import Highcharts from "highcharts";
require("highcharts/modules/map")(Highcharts)

window.Highcharts = Highcharts;